import { ICta } from 'interfaces/IHxTraining';

export const getUrlFromCta = (cta?: ICta) => {
  if (!cta) return '';
  if (cta.linkType === 'file') {
    return cta.linkedFile;
  }
  return cta.url;
};
